import { curry, set } from 'lodash/fp';
import injectProps from './injectProps';
/**
 * @deprecated
 * Inject custom prop into selector
 *
 * @param {(string|Array)} path - key or path at which prop value should be injected
 * @param {*} value - value of injected prop
 * @param {Function} selector - initial selector to be modified
 *
 * @returns {Function} selector - modified selector with injected props
 *
 * @example
 * injectProps('form', FORM_ID, valuesSelector)
 */

export var injectProp = curry(function (path, value, selector) {
  return injectProps(set(path, value, {}), selector);
});
export default injectProp;